import { abortController } from '@wallbox/http'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export default function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (to.name !== from.name) {
    abortController.abort('default')
  }
  next()
}
